import {
    CampaignType,
    GetOffersResult,
    campaignTypeSchema,
} from '@west-australian-newspapers/subscription-offer-types'
import { Logger } from '@west-australian-newspapers/typescript-log'
import { SwgCampaignOfferValues } from '../campaigns'
import { getIntro25OfferRrmeCampaignValues } from './Rrme25OffIntroOffer'
import { getDefaultRrmeCampaignValues } from './RrmeDefaultOfferCampaign'
import { getFreeTrialOfferRrmeCampaignValues } from './RrmeFreeTrialOffer'
import { getUniversityOfferRrmeCampaignValues } from './RrmeUniOfferCampaign'

/**
 * Return if the provided campaign offer (from LaunchDarkly feature 'swg-campaign-offer')
 * is valid for the current environment.
 */
export const isCampaignOfferValid = (
    campaignOffer: string | undefined,
): campaignOffer is CampaignType => {
    if (!campaignOffer) {
        return false
    }

    const result = campaignTypeSchema.safeParse(campaignOffer)

    return result.success
}

export const getRrmeCampaignOfferValues = (
    campaignOffer: CampaignType,
    logger: Logger,
    campaignOffers?: GetOffersResult,
): SwgCampaignOfferValues | undefined => {
    switch (campaignOffer) {
        case 'university-offer':
            return getUniversityOfferRrmeCampaignValues(logger, campaignOffers)
        case 'free-trial-offer':
            return getFreeTrialOfferRrmeCampaignValues(logger, campaignOffers)
        case 'intro-25-offer':
            return getIntro25OfferRrmeCampaignValues(logger, campaignOffers)
        // annual-package handling is included in default case
        case 'default-annual-package':
        default:
            return getDefaultRrmeCampaignValues(logger, campaignOffers)
    }
}
